export const TOKEN_EXPIRED = 'fcmTokenExpired' as const;
export const NEW_TOKEN = 'fcmTokenNew' as const;
export const FCM_TOKENS_FIELD = 'hidden.fcmTokens' as const;
